import { DeleteOutlined, EditOutlined } from '@ant-design/icons'
import { Button, Popconfirm } from 'antd'
import React from 'react'
import styled from 'styled-components'

const BlockText = styled.div`
  font-family: var(--font-secondary);
  font-weight: 600;
  color: ${({ theme, blocked }) =>
    !blocked ? theme.colors.danger : theme.colors.primary};
  cursor: pointer;
`

export const ActionBox = ({ onEdit, onDelete, onBlock, item, onRestore, onReview, withOutConfirmation }) => {

  return (
    <div>
      <div className="d-flex">
        {onEdit && (
          <Button default onClick={() => onEdit()} className="me-3">
            <EditOutlined />
          </Button>
        )}
        {onDelete && (
          withOutConfirmation ? (
            <Button danger onClick={() => onDelete()}>
              <DeleteOutlined />
            </Button>
          ) : (
            <Popconfirm
              title="Are you sure you want to delete?"
              onConfirm={() => onDelete()}
            >
              <Button danger>
                <DeleteOutlined />
              </Button>
            </Popconfirm>
          )
        )}
        {onBlock && (
          withOutConfirmation ? (
            <BlockText onClick={() => onBlock()} blocked={item.isBlocked}>
              {!item.isBlocked ? 'Un Block' : 'Block'}
            </BlockText>
          ) : (
            <Popconfirm
              title={`Are you sure you want to ${item.isBlocked ? 'Un Block' : 'Block'}?`}
              onConfirm={() => onBlock()}
            >
              <BlockText blocked={item.isBlocked}>
                {!item.isBlocked ? 'Block' : 'Unblock'}
              </BlockText>
            </Popconfirm>
          )
        )}
        {onReview && (
          withOutConfirmation ? (
            <BlockText onClick={() => onReview()}>Review</BlockText>
          ) : (
            <Popconfirm
              title="Are you sure you want to review?"
              onConfirm={() => onReview()}
            >
              <BlockText>Review</BlockText>
            </Popconfirm>
          )
        )}

        {onRestore && (
          withOutConfirmation ? (
            <Button danger onClick={() => onRestore()}>
              <BlockText>Restore</BlockText>
            </Button>
          ) : (
            <Popconfirm
              title="Are you sure you want to Restore?"
              onConfirm={() => onRestore()}
            >
              <BlockText>Restore</BlockText>
            </Popconfirm>
          )
        )}
      </div>
    </div>
  );
};